import { Component, NgZone } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { InmatchPage } from './page';
import { AppConfigService } from 'src/app/services/app-config.service';
import { RestService } from 'src/app/services/rest.service';
import { Router } from '@angular/router';
import { UserEntitlementsService } from 'src/app/services/user-entitlements.service';

@Component({
  selector: 'app-page-recs',
  template: '<div class="react-page" #container></div>'
})
export class PageRecsComponent extends ReactPageComponent {

  constructor(
    private appConfigService: AppConfigService,
    rest: RestService,
    router: Router,
    public zone: NgZone,
    private userEntitlementsService: UserEntitlementsService
) {
    super(rest, router, zone, appConfigService);
    this.appConfigService = appConfigService;
}

  get Component(){
    return InmatchPage;
  }

  async reactPageWillMount(): Promise<void> {
    if (this.appConfigService.shouldEnforceUserEntitlements()) {
        console.log('Loading entitlements...');
        await this.userEntitlementsService.ensureEntitlementsAreLoaded();
        console.log('Entitlements were loaded');
    }
  }
}
